<template>
<div class="edit">
  <div class='detail'>
    <div class='detail_contents'>
      <div class='count_units'>
        <div class='count_units_label assessment_title_label'>
          {{countUnitsLabel}}
        </div>
        <div class='radio_buttons' id='count_units'>
          <label>
            <input type='radio' id='day' name='count_units' checked value='0'>
            {{dayLabel}}
          </label>
          <label>
            <input type='radio' id='week' name='count_units' value='1'>
            {{weekLabel}}
          </label>
          <label>
            <input type='radio' id='month' name='count_units' value='2'>
            {{monthLabel}}
          </label>
        </div>
      </div>
      <div class='aggregate_target'>
        <div class='attention'>
          {{totalWarning}}
        </div>
        <div class='table_cell'>
          <div class='aggregate_target_label assessment_title_label'>
            {{aggregateTargetLabel}}
          </div>
          <div class='all_label'>
            <input type='checkbox' class='checkbox' id='all_checkbox'>
            <label for='all_checkbox'>{{allLabel}}</label>
          </div>
          <div class='posts_table'>
            <label class='title assessment_title_label'>
              {{postsLabel}}
            </label>
            <div class='table'>
              <table class='table_header' border='1' cellpadding='2' bordercolor='#fff' style='border-collapse: collapse'>
                <tr>
                  <th class='table_first_child post_table_header_first_padding'></th>
                  <th class='post_table_content' align='left'>
                    {{postNameLabel}}
                  </th>
                </tr>
              </table>
              <div class='edit_table_contents'>
                <table class='edit_table_content' border='1' cellpadding='2' bordercolor='#fff' style='border-collapse: collapse'>
                  <tr class='table_row' v-for='post in posts' :key='post.postId' @click='checkedPostsAction(post)'>
                    <td class='table_first_child'>
                      <input type="checkbox" class="checkbox" :checked='post.checked'>
                    </td>
                    <td class='post_table_content'>
                      {{post.postName}}
                    </td>
                  </tr>
                </table>
              </div>
            </div>
          </div>
          <div class='users_table'>
            <label class='title assessment_title_label'>
              {{usersLabel}}
            </label>
            <div class='table'>
              <table class='table_header' border='1' cellpadding='2' bordercolor='#fff' style='border-collapse: collapse'>
                <tr>
                  <th class='table_first_child user_table_header_first_padding'></th>
                  <th align='left' class='user_secand_child'>
                    {{userIdLabel}}
                  </th>
                  <th align='left' class='user_third_child'>
                    {{userNameLabel}}
                  </th>
                </tr>
              </table>
              <div class='edit_table_contents'>
                <table class='edit_table_content' border='1' cellpadding='2' bordercolor='#fff' style='border-collapse: collapse'>
                  <tr class='table_row' v-for='user in users' :key='user.userId' @click='checkedUsersAction(user)'>
                    <td class='table_first_child'>
                      <input type="checkbox" class="checkbox" :checked='user.checked'>
                    </td>
                    <td class='user_secand_child user_table_content'>
                      {{user.userId}}
                    </td>
                    <td class='user_third_child user_table_content'>
                      {{user.familyName}}{{user.name}}
                    </td>
                  </tr>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
</template>

<script>

export default {
  data () {
    return {
      totalWarning: '*集計対象の選択は合わせて5件まで選択できます。',
      countUnitsLabel: '集計単位',
      dayLabel: '日',
      weekLabel: '週',
      monthLabel: '月',
      aggregateTargetLabel: '集計対象',
      allLabel: '全体',
      postsLabel: '所属',
      postNameLabel: '所属名',
      usersLabel: 'ユーザ',
      userIdLabel: 'ユーザID',
      userNameLabel: 'ユーザ名',
      checkedUsersList: [],
      checkedPostsList: [],
      allChecked: false,
      postsChecked: false,
      usersChecked: false
    }
  },
  computed: {
    posts () {
      return this.$store.state.corporations.posts
    },
    users () {
      return this.$store.state.corporations.users
    },
    errorMsg () {
      return this.$store.state.error.errorMsg
    }
  },
  components: {
  },
  async created () {
    await this.$store.dispatch('clearUserAndPostCheck')
  },
  methods: {
    checkedPostsAction (e) {
      // クリックしたリストのチェックボックスをチェックする。
      this.$store.dispatch('corporations/checkedPostsAction', e)
    },
    checkedUsersAction (e) {
      // クリックしたリストのチェックボックスをチェックする。
      this.$store.dispatch('corporations/checkedUsersAction', e)
    }
  }
}
</script>
<style scoped>
.edit {
  width: 100%;
  border: none;
}
.detail {
  height: 100%;
}
.detail_contents {
  width: 100%;
  height: 100%;
  padding: 0;
  overflow-y: auto;
}
.count_units {
  padding-top: 0;
}
.count_units::after,
.count_units::before {
  width: 0;
}
.post_table_header_first_padding,
.user_table_header_first_padding {
  padding: 0 17px;
}
</style>



// WEBPACK FOOTER //
// src/components/masterPanel/masterView/CorporationView/logExportCompornents/assessmentInfoDetail.vue